import React from 'react'
import PropTypes from 'prop-types'
import {Switch} from 'antd'
import { Form } from '@ant-design/compatible';

class InputSwitch extends React.Component {
  render() {
    const { name, rules, initialValue, form, formItemStyle } = this.props
    const inputError = form.isFieldTouched(name) && form.getFieldError(name)

    return (
      <Form.Item
        style={formItemStyle}
        validateStatus={inputError ? 'error' : ''}
        help={inputError || ''}>
        {form.getFieldDecorator(name, { rules, initialValue, valuePropName: 'checked' })(
          <Switch />
        )}
      </Form.Item>
    )
  }
}

InputSwitch.propTypes = {
  form: PropTypes.object.isRequired,
  rules: PropTypes.array,
  name: PropTypes.string.isRequired,
  formItemStyle: PropTypes.object,
}

export default InputSwitch
